import { CustomerContext, CustomerMutations, CustomerActions } from "./types";
import{ CustomerSchema } from "@/models/customer_schema";
import CustomerService from "@/services/customer_service";
import { EventBus } from "@/events/index";
import { SalesRegions, SalesRegionsStringType } from "@/models/map/region_type";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { CustomerStatus } from "@/models/customer";

const formatSalesRegion = (str: string): SalesRegionsStringType => {
  if (str.includes('-')) {
        return str.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-') as SalesRegionsStringType;
  } else {
        return str.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') as SalesRegionsStringType;
  }
}

export const addAllCustomers = async (
  context: CustomerContext,
  payload?: SalesRegions["string"]
): Promise<void> => {
  const customerService = new CustomerService();
  try {
    const res = await customerService.getCustomers(payload);
    res.forEach(customer => {
      customer.sales_region = formatSalesRegion(customer.sales_region);
    })
    context.commit(CustomerMutations.SetCustomer, res);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      APIError.popup(err.message);
    } else {
      GenericError.popup(err.message);
    }
  }
};

export const fetchSingleCustomer = async (
  context: CustomerContext,
  payload: string
): Promise<CustomerSchema> => {
  const customerService = new CustomerService();
  let res;
  try {
    res = await customerService.getSingleCustomer(payload);
    res.sales_region = formatSalesRegion(res.sales_region);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      if (err.statusCode === 403) {
        APIError.restricted();
      } else {
        APIError.popup(err.message);
      }
    } else {
      GenericError.popup(err.message);
    }
  }
  context.dispatch(CustomerActions.EditCustomer, res);
  return res;
};

export const editCustomer = (
  context: CustomerContext,
  payload: CustomerSchema
): void => {
  const store = context.state.customers;
  const results = [] as CustomerSchema[];
  store.forEach((customer) => {
    if (customer._id === payload._id) {
      results.push(payload);
    } else {
      results.push(customer);
    }
  });
  context.commit(CustomerMutations.SetCustomer, results);
  context.commit(CustomerMutations.SetSelected, payload);
};

export const addCustomer = (
  context: CustomerContext,
  payload: CustomerSchema
): void => {
  const customers = context.state.customers;
  customers.unshift(payload);
  context.commit(CustomerMutations.SetCustomer, customers);
};

export const deleteCustomer = async (
  context: CustomerContext,
  payload: string
): Promise<void> => {
  const customerService = new CustomerService();
  let results = [] as CustomerSchema[];
  const customers = context.state.customers;
  try {
    await customerService.deleteCustomer(payload);
    results = customers.filter((customer) => {
      return customer._id !== payload;
    });
    context.commit(CustomerMutations.SetCustomer, results);
  } catch (err) {
    if (err instanceof AuthError) {
      AuthError.logout();
    } else if (err instanceof APIError) {
      APIError.popup(err.message);
    } else {
      GenericError.popup(err.message);
    }
  }
};
